export class Subject {
    constructor() {
        this.observers = [];
    }

    subscribe(callback) {
        this.observers.push(callback);
        return () => {
        this.observers = this.observers.filter(fn => fn !== callback);
        };
    }

    // Emit an event to all listeners
    next(value) {
        this.observers.forEach(fn => fn(value));
    }
}